export default {
  'nav.brandVision': '品牌愿景',
  'nav.strategicPositioning': '战略定位',
  'nav.coreBusiness': '核心业务',
  'nav.competitiveAdvantage': '竞争优势',
  'nav.developmentRoadmap': '发展路线',
  'nav.careers': '人才招聘',
  'nav.backToHome': '返回首页',
  'nav.brandStory': '品牌故事',

  'footer.companyName': '艾思国际控股有限公司',
  'footer.companyNameEn': 'AX AXIS INTERNATIONAL HOLDING LIMITED',
  'footer.tagline': '让数据回归核心。从底层芯片到顶层架构，构建全链路私域数据生态。',
  'footer.business': '业务板块',
  'footer.business.storageChips': '存储芯片',
  'footer.business.terminalDevices': '终端设备',
  'footer.business.privateCloudNAS': '私有云 NAS',
  'footer.business.enterpriseNetwork': '企业网络',
  'footer.aboutUs': '关于我们',
  'footer.aboutUs.brandVision': '品牌愿景',
  'footer.aboutUs.strategicPositioning': '战略定位',
  'footer.aboutUs.developmentRoadmap': '发展路线',
  'footer.aboutUs.careers': '人才招聘',
  'footer.contact': '联系合作',
  'footer.addressLine1': '香港中环德辅道中26号华懋中心二期19楼A室',
  'footer.phoneLabel': '电话：',
  'footer.emailLabel': '邮箱：',
  'footer.copyright': '© {{year}} AX Axis International Holding Limited. All rights reserved.',

  'contact.infoTitle': '联系方式',
  'contact.addressTitle': '公司地址',
  'contact.emailTitle': '电子邮箱',
  'contact.reachUs': '',
  'contact.web3MissingKey': 'Web3Forms 访问密钥未配置，请联系管理员。',

  'contact.label': '',
  'contact.title': '联络我们',
  'contact.description': '有任何疑问或合作意向，欢迎留言，我们将尽快与您取得联系。',
  'contact.nameLabel': '姓名',
  'contact.namePlaceholder': '请输入您的姓名',
  'contact.emailLabel': '邮箱',
  'contact.emailPlaceholder': 'your@email.com',
  'contact.phoneLabel': '电话',
  'contact.phonePlaceholder': '您的联系电话（选填）',
  'contact.messageLabel': '查询内容',
  'contact.messagePlaceholder': '请描述您的需求或问题...',
  'contact.submit': '发送留言',
  'contact.submitting': '发送中...',
  'contact.success': '留言发送成功！',
  'contact.error': '请检查填写内容后重试。',
};